import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SidebarLayout from "../components/SidebarLayout";
import Dashboard from "../components/Dashboard";
import CohortCharts from "../components/CohortCharts";
import Audiences from "../components/Audiences";
import Attribution from "../components/Attribution";
import About from "../components/About";
import Home from "../components/Home";
import NotFound from "../components/NotFound";
import IntegrationsPage from "../components/IntegrationsPage";
import PricingPage from "../components/PricingPage";
import Login from "../components/Login";
import Signup from "../components/Signup";
import NotificationsPage from "../components/NotificationsPage";
import SettingsPage from "../components/SettingsPage";
import Onboarding from "../components/Onboarding";

const AppRoutes = () => {
  const [authState, setAuthState] = useState(
    localStorage.getItem("isLoggedIn") === "true" || localStorage.getItem("isSignedUp") === "true"
  );
  const navigate = useNavigate();

  // Effect to listen for changes to localStorage (e.g., other tabs or programmatic changes)
  useEffect(() => {
    const syncAuthState = () => {
      const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
      console.log("Syncing authState with localStorage:", isLoggedIn);
      setAuthState(isLoggedIn);
    };

    window.addEventListener("storage", syncAuthState);

    // Run sync immediately on mount
    syncAuthState();

    return () => window.removeEventListener("storage", syncAuthState);
  }, []); // Empty dependency array ensures this effect runs once on mount

  const handleLogin = () => {
    console.log("User logged in");
    localStorage.setItem("isLoggedIn", "true");
    setAuthState(true); // Update auth state
    navigate("/dashboard"); // Redirect to dashboard
  };

  const handleSignup = () => {
    console.log("User signed up");
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("isSignedUp", "true");
    setAuthState(true); // Update auth state
    navigate("/onboarding"); // Redirect to dashboard
  };

  const handleLogout = () => {
    console.log("User logged out");
    localStorage.removeItem("isLoggedIn");
    setAuthState(false); // Update auth state
    navigate("/login"); // Redirect to login page
  };

  return (
    <>
      <Header isLoggedIn={authState} onLogout={handleLogout} />
      <main style={{ padding: "16px" }}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home onLogin={handleLogin} />} />
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/signup" element={<Signup onSignupComplete={handleSignup} />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/onboarding" element={
              localStorage.getItem("isSignedUp") === "true" ? (
                <Onboarding onComplete={() => {
                  localStorage.removeItem("isSignedUp"); // Clear signup state
                  localStorage.setItem("isLoggedIn", "true"); // Set logged-in state
                }} />
              ) : (
                <Navigate to="/signup" />
              )
            }
          />


          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              localStorage.getItem("isLoggedIn") === "true" ? (
                <SidebarLayout>
                  <Dashboard onLogout={handleLogout} />
                </SidebarLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/integrations"
            element={
              authState ? (
                <SidebarLayout>
                  <IntegrationsPage />
                </SidebarLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/cohort-charts"
            element={
              authState ? (
                <SidebarLayout>
                  <CohortCharts />
                </SidebarLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/audiences"
            element={
              authState ? (
                <SidebarLayout>
                  <Audiences />
                </SidebarLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/attribution"
            element={
              authState ? (
                <SidebarLayout>
                  <Attribution />
                </SidebarLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/notifications"
            element={
              authState ? (
                <SidebarLayout>
                  <NotificationsPage />
                </SidebarLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/settings"
            element={
              authState ? (
                <SidebarLayout>
                  <SettingsPage />
                </SidebarLayout>
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          {/* Catch-All Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

export default AppRoutes;
